import React from "react";
import { Navigate, useParams, useSearchParams } from "react-router-dom";
import { useLearner } from "../../contexts/LearnerContext";
import { bookPath, learnPath, lessonPath, practicePath } from "../../utils/routes";
interface LegacyRedirectProps {
  kind: "course" | "lesson" | "book";
}

/** Old /app/course/:id, /app/lesson/:id and /app/read/:id links → new /app/learn/:from/:to URLs. */
export function LegacyRedirect({
  kind
}: LegacyRedirectProps) {
  const {
    id = ""
  } = useParams();
  const [params] = useSearchParams();
  const {
    courses,
    activeCourse
  } = useLearner();
  const courseId = kind === "lesson" ? params.get("course") : id;
  const course = courses.find(c => c.id === courseId) ?? activeCourse;
  if (!course) return <Navigate to="/app/courses" replace data-id="element-1331" data-mp="nfly0166gywr" />;
  if (kind === "course") return <Navigate to={learnPath(course)} replace data-id="element-1332" data-mp="2k9gzffcwdjs7" />;
  if (kind === "book") return <Navigate to={bookPath(course)} replace data-id="element-1333" data-mp="2p78nfyaf8lr4" />;
  return <Navigate to={id === "practice" ? practicePath(course) : lessonPath(course, id)} replace data-id="element-1334" data-mp="2p80j1940qjhe" />;
}